import React from 'react';

import {LinkProps} from "../../../../core/components/link/link-composer";
import {LeftArrow} from "../../../../core/icons/arrows/left-arrow";
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetNavigationButton} from "./entity-scores-widget.navigation-button";
import styles from "../../styles/entity-scores-widget.module.scss";
import {ENTITY_SCORES} from "../../entity-scores-widget.consts";
import {
  EntityContainerHashParamsModel
} from "../../../../core/components/router/models/entity-container-hash-params-model";

export class EntityScoresWidgetNavigationButtonsResultsProps extends BaseProps {
}

export const EntityScoresWidgetNavigationButtonsResults = ({
                                                             controller,
                                                             onFilterChange
                                                           }: EntityScoresWidgetNavigationButtonsResultsProps) => {
  const {terms: {WEB_RESULTS_BUTTON}, state} = controller;
  const {entity} = state;

  const buttonProps: LinkProps = {
    controller,
    filterType: ENTITY_SCORES.ANALYTICS.FILTERS.results,
    linkParams: new EntityContainerHashParamsModel({results: ENTITY_SCORES.URL_FILTERS.results}),
    onClick: onFilterChange ? () => onFilterChange(ENTITY_SCORES.FILTERS_INDEX.results, true) : null
  }

  return (
    <EntityScoresWidgetNavigationButton {...buttonProps}>
      <LeftArrow className={classNames(styles.navigation_arrow)}/>
      {WEB_RESULTS_BUTTON?.format({'ENTITY_NAME': entity?.name})}
    </EntityScoresWidgetNavigationButton>
  )
}
